"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _imageSrc = require("../../lib/imageSrc");
var _CardFooter = _interopRequireDefault(require("../../components/CardFooter"));
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Media card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Media card
 */
function MediaCard(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  var mediaAlignment = (0, _lodash.isEmpty)(extractedFields.MediaAlignment.value) ? 'left' : extractedFields.MediaAlignment.value;
  var mediaItemSize = (0, _lodash.isEmpty)(extractedFields.MediaItemSize.value) ? 'lg' : extractedFields.MediaItemSize.value;
  var MediaContentCentered = props => {
    var titleClass = mediaAlignment === 'center-with-content' ? 'mm-text-center' : 'card-title';
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
      className: "".concat(mediaAlignment === 'center-with-content' ? 'align-items-center' : '')
    }, !(0, _lodash.isEmpty)(props.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, props.Eyebrow.value), /*#__PURE__*/_react.default.createElement(MediaImage, props), !(0, _lodash.isEmpty)(props.Title.value) && (0, _titleHeadTag.headTagTitle)(props.Title, titleClass, props.TitleSize.value), /*#__PURE__*/_react.default.createElement(MediaTextNFooter, props));
  };
  var MediaImage = props => {
    var alignMentClass = mediaAlignment.includes('center') ? 'align-self-center' : '';
    if (!(0, _lodash.isEmpty)(props.MediaIcon.value)) {
      alignMentClass = mediaAlignment === 'left' ? 'media-right-margin' : alignMentClass;
      var iconClass = props.Variant.value.includes('dark') ? props.MediaIcon.value + '-white' : props.MediaIcon.value;
      return /*#__PURE__*/_react.default.createElement("picture", {
        className: "mm-img ".concat(alignMentClass)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icon-".concat(mediaItemSize, " ").concat(iconClass)
      }));
    } else if (!(0, _lodash.isEmpty)(props.MediaIllustration.value)) {
      return /*#__PURE__*/_react.default.createElement("picture", {
        className: "mm-img ".concat(alignMentClass)
      }, /*#__PURE__*/_react.default.createElement("span", {
        role: "img",
        className: "mm-illustration-buffer ".concat(props.MediaIllustration.value),
        title: props.MediaIllustration.value
      }));
    } else if (!(0, _lodash.isEmpty)(props.MediaImage.value)) {
      if (props.TransformImageRound.value) {
        return /*#__PURE__*/_react.default.createElement("picture", {
          className: "".concat(alignMentClass, " mm-img-circle--").concat(mediaItemSize)
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: (0, _imageSrc.imageHref)(props.MediaImage.value),
          alt: props.MediaImage.value.alt
        }));
      } else {
        alignMentClass = mediaAlignment === 'left' ? 'media-right-margin' : alignMentClass;
        return /*#__PURE__*/_react.default.createElement("picture", {
          className: "".concat(alignMentClass, " mm-img-square--").concat(mediaItemSize)
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: (0, _imageSrc.imageHref)(props.MediaImage.value),
          alt: props.MediaImage.value.alt
        }));
      }
    } else return null;
  };
  var MediaBody = props => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, !(0, _lodash.isEmpty)(props.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, props.Eyebrow.value), !(0, _lodash.isEmpty)(props.Title.value) && (0, _titleHeadTag.headTagTitle)(props.Title, 'card-title', props.TitleSize.value));
  };
  var MediaTextNFooter = props => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, (0, _richTextField.parseHTML)(props.PreviewText)), /*#__PURE__*/_react.default.createElement(_CardFooter.default, {
      buttonType: props.ButtonType.value,
      linkUrl: linkUrl,
      linkTarget: linkTarget,
      linkAlt: linkAlt,
      buttonTxt: props.Text.value,
      ctaIcon: props.ctaIcon.value,
      ctaIconDirection: props.ctaIconPlacement.value,
      callOut: (0, _richTextField.parseHTML)(props.Callout),
      ctaDataId: props.ctaDataId.value
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container media-card"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-content-object"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: extractedFields.Variant.value
  }, mediaAlignment.includes('center') && /*#__PURE__*/_react.default.createElement(MediaContentCentered, extractedFields), mediaAlignment === 'left' && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object"
  }, /*#__PURE__*/_react.default.createElement(MediaImage, extractedFields), /*#__PURE__*/_react.default.createElement(MediaBody, extractedFields)), /*#__PURE__*/_react.default.createElement(MediaTextNFooter, extractedFields)), mediaAlignment === 'right' && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object"
  }, /*#__PURE__*/_react.default.createElement(MediaBody, extractedFields), /*#__PURE__*/_react.default.createElement(MediaImage, extractedFields)), /*#__PURE__*/_react.default.createElement(MediaTextNFooter, extractedFields)))));
}
var _default = exports.default = MediaCard;